import React, { useState } from 'react'
import {FileTextOutlined} from '@ant-design/icons';
import {Modal, Space } from 'antd';
import FeedbackDesc from './FeedbackDesc';


function FeedbackCheck(props) {
    const [open,setOpen] = useState(false)
   
    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space><FileTextOutlined/>{props.bfkjc_name}</Space>
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <FeedbackDesc
                    bfkjc_id={props.bfkjc_id}
                />          
            </Modal>
        </>
    )
}

export default FeedbackCheck